import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import { Page } from '../page/Page'
import { TopBar } from '../page/TopBar'
import { TopBarBackButton, TopBarOptionsButton } from '../page/TopBarButtons'

interface Props {
    deps: CommonDeps
    name: string
    onOptionsClick?: () => void
    onBackClick: () => void
    children?: React.ReactElement<unknown>
    footer?: React.ReactElement<unknown>
}

export class SubjectPickerPage extends React.Component<Props> {
    public render = () => {
        return (
            <div className="AppCore__report__SubjectPickerPage">
                <Page
                    deps={this.props.deps}
                    header={
                        <TopBar
                            deps={this.props.deps}
                            leftButton={() => <TopBarBackButton onClick={this.props.onBackClick} />}
                            rightButton={() =>
                                this.props.onOptionsClick && <TopBarOptionsButton onClick={this.props.onOptionsClick} />
                            }
                        >
                            {() => <>{this.props.name}</>}
                        </TopBar>
                    }
                    footer={this.props.footer}
                >
                    {this.props.children}
                </Page>
            </div>
        )
    }
}
